<template>
	<div class="hiq-toc__wrapper"
		v-if="isToc && !isMobile && items.length > 0"
		:style="{height:height + 'px'}">
		<div class="hiq-toc" role="navigation" aria-label="Ankarlänkar">
			<h2 class="hiq-toc-title">
				Innehåll på sidan
			</h2>
			<ul class="hiq-toc-list" v-if="items.length > 0">
				<li class="hiq-toc-item" v-for="item in items" :key="item.id">
					<a class="hiq-toc-item__link" @click.prevent="onScroll(item.id)" :href="'#' + item.id">
						{{ item.title }}
					</a>
				</li>
			</ul>
		</div>
	</div>
</template>

<script>
export default {
	name: 'app',
	data() {
		return {
			observer: null,
			isMobile: false,
			items: [],
			height: 0,
		}
	},
	computed: {
		isToc(){
			return this.$store.getters.isToc;
		}
	},
	methods: {
		onScroll(id) {
			let element = document.getElementById(id);
      let top = window.pageYOffset + element.getBoundingClientRect().top;

      window.scrollTo({
				top: top,
				behavior: 'smooth'
			});
		},
		onElementObserved(entries) {
			let element = document.querySelector('.hiq-toc');
			if(element) {
				entries.forEach(({ target, isIntersecting }) => {
					const id = target.getAttribute('id');
					if (isIntersecting) {
						element
							.querySelector(`li a[href="#${id}"]`)
							.parentElement.classList.add('active')
					} else {
						element
							.querySelector(`li a[href="#${id}"]`)
							.parentElement.classList.remove('active')
					}
				})
			}
			
		},
	},
	mounted() {
		// Check if its mobile view
	if(window.innerWidth < 1024){
      this.isMobile = true;
    } else {
      this.isMobile = false;
    }
    window.addEventListener('resize', () => {
      if(window.innerWidth < 1024) {
        this.isMobile = true;
      } else {
        this.isMobile = false;
		let height = document.querySelector('main').offsetHeight;//includes margin,border,padding
      }
    });

		if(!this.isMobile) {
			let mittenspaltElement = document.getElementById('Mittenspalt').parentElement;

			mittenspaltElement.querySelectorAll('.hiq-h2').forEach((h2) => {
				const nextSibling = h2.nextElementSibling;
				if (nextSibling && nextSibling.classList.contains('hiq-decoration-collapsable-h2')) {
					return;
				}

				const titleSpan = h2.querySelector('.env-m-right--x-large');

				this.items.push({
					id: h2.id,
					title: titleSpan ? titleSpan.innerHTML : h2.innerHTML,
				})

				this.observer.observe(h2)
			})
		}
		window.addEventListener('DOMContentLoaded', () => {
			let height = document.querySelector('main').offsetHeight;//includes margin,border,padding
			this.height = height - 95;
		})
  	},
	created() {
		// root = null = document (default root for intersection)
		// threshold 1.0 = 100% of hiq-h2 is visible in this example
		this.observer = new IntersectionObserver(this.onElementObserved, {
			root: null,
			threshold: 1.0,
    })
	},
	beforeDestroy() {
    this.observer.disconnect();
  },
}
</script>
